module.exports = __webpack_public_path__ + "static/media/banner.b6634e08.png";